import React from 'react';
import { Controller } from 'react-hook-form';

import { CanvasSizeEnum } from 'generated-api';
import Select, { createSelectCollection } from 'ui/Select';

import { canvasSizeOptions } from '../../constants';
import { useSankeyFormContext } from '../../contexts/sankeyFormContext';

const CanvasSizeSelect: React.FC = () => {
  const { form } = useSankeyFormContext();
  const collection = createSelectCollection(canvasSizeOptions);

  return (
    <Controller
      name="canvas_size"
      control={form.control}
      render={({ field }) => (
        <Select
          id={field.name}
          name={field.name}
          value={field.value ? [field.value] : []}
          onValueChange={({ value }) => {
            // Update the canvas size selection directly
            const canvasSize = value[0] as CanvasSizeEnum;
            field.onChange(canvasSize);
            // Get selected width and height based on the canvas size, and update them
            // in the form (unless the size is 'custom', in which case we leave them)
            const { width, height } =
              canvasSizeOptions.find((o) => o.value === canvasSize) ?? {};
            if (width && height) {
              form.setValue('canvas_width', width, { shouldDirty: true });
              form.setValue('canvas_height', height, { shouldDirty: true });
            }
          }}
          onInteractOutside={() => field.onBlur()}
          collection={collection}
          size="sm"
        />
      )}
    />
  );
};

export default CanvasSizeSelect;
